/**
 * PC端学院中使用到的客户端接口封装
 */

 import execService from '@wps/wps_client_api/exec';

 class ClientApi {
   constructor() {
     const paymentApiPrefix = 'common.payment';
     this.apis = {
       openTagByVbaPay: `${paymentApiPrefix}.openTagByVbaPay`
     }
   }

   /**
    * 打开VBA支付的弹窗
    * @param {*} url
    */
   openTagByVbaPay(url) {
     return execService.exec(this.apis.openTagByVbaPay, { url });
   }
 }

 export default new ClientApi();
